import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { keycloak } from "../app/lib/keycloak"
import { PollingResponse } from "../app/lib/polling/dto"

export const baseQuery = fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers) => {
        const token = keycloak.token
        if (token) headers.set('authorization', `Bearer ${token}`)
        return headers
    }
})


export const baseQueryWithReauth = async (_args: any, _api: any, _extraOptions: any) => {
    let result = await baseQuery(_args, _api, _extraOptions)
    if (result?.error?.status === 401) {
        const refreshed = await keycloak.updateToken(30)
        if (refreshed) {
            result = await baseQuery(_args, _api, _extraOptions)
        } else {
            keycloak.logout()
        }
    }
    return result
}

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Database', 'Companies', 'People', 'Users', 'Contacts', 'Targetlist', 'Projects', 'Mails', 'Recalls', 'Privacy'],
    endpoints: (build) => ({
        checkJobStatus: build.query<PollingResponse, string>({
            query: (jobId) => ({
                url: `jobs/${jobId}`,
                method: 'GET',
            }),
        }),
    }),
})

export const {
    useCheckJobStatusQuery
} = baseApi